export default "<article>\n  <div *ngIf=\"status\"><strong>{{ status?.state }}</strong></div>\n<p>Press any key to continue!</p>\n</article>\n"